// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"d8bec398","453":"3d9be1ae","626":"211edab5"}[chunkId] + ".chunk.js";
};